export * as Check from './check';
export * as Guard from './guard';

export type { TypeCheckOptions, ValidationErrorCallback } from './check';
export type { GuardOptions } from './guard';
export type { IdentifiedSchema } from './schema';
export type {
  Falsey,
  LiteralUnion,
  PartialRecord,
  PublicInterface,
  RecordEntries,
  RecursivePartial,
  Truthy,
} from './types';
